import { useMutation } from "@tanstack/react-query";
import {
  checkOTPParamType,
  forgotPasswordParamType,
  sendOTPParamType,
  signinParamType,
  signupParamType,
} from "./data";
import {
  apiCheckOTP,
  apiForgotPassword,
  apiSendOTP,
  apiSendRegisterOTP,
  apiSignIn,
  apiSignOut,
  apiSignUp,
} from "./service";

export const useSignin = () => {
  return useMutation({
    mutationFn: ({ params }: { params: signinParamType }) => apiSignIn(params),
  });
};

export const useCheckOTP = () => {
  return useMutation({
    mutationFn: ({ params }: { params: checkOTPParamType }) =>
      apiCheckOTP(params),
  });
};

export const useSendOtp = () => {
  return useMutation({
    mutationFn: ({ params }: { params: sendOTPParamType }) =>
      apiSendOTP(params),
  });
};

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: ({ params }: { params: forgotPasswordParamType }) =>
      apiForgotPassword(params),
  });
};

export const useSignOut = () => {
  return useMutation({
    mutationFn: () => apiSignOut(),
  });
};

export const useSendRegisterOtp = () => {
  return useMutation({
    mutationFn: ({ params }: { params: sendOTPParamType }) =>
      apiSendRegisterOTP(params),
  });
};

export const useSignup = () => {
  return useMutation({
    mutationFn: ({ params }: { params: signupParamType }) => apiSignUp(params),
  });
};
